import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=319a3cf2&scoped=true&"
import script from "./BaseImage.vue?vue&type=script&lang=js&"
export * from "./BaseImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseImage.vue?vue&type=style&index=0&id=319a3cf2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a3cf2",
  null
  
)

export default component.exports